import classNames from 'classnames';
import styles from './styles/AsideModal.module.scss';

type Props = {
  active: boolean;
  positionX: string;
  width?: number;
  height?: number;
  onClose: () => void;
  children: any;
};

const AsideModal = ({
  active,
  positionX = 'left',
  width = 80,
  height = 0,
  onClose,
  children,
}: Props) => {
  return (
    <div
      className={classNames(styles['meganav__body__mobile'], {
        [styles.active]: active,
        [styles.left]: positionX === 'left',
        [styles.right]: positionX === 'right',
      })}
      style={{ width: `${width}%`, ...(height ? { height: `${height}px` } : {}) }}
    >
      <div onClick={onClose} role="button" className={`d-none d-sm-block ${styles.overlay}`} />
      <div
        className={classNames(`py-5 background-white ${styles.meganav__body__mobile__inner}`, {
          [styles.left]: positionX === 'left',
          [styles.right]: positionX === 'right',
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default AsideModal;
